module.exports = __webpack_public_path__ + "img/shj.datang.1cdf8916.png";